import styled from 'styled-components';

export const ActiveZoneIndicator = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    padding: 0.8rem;
    background-color: ${({ theme }) => theme.colors.coral[100]};
    border-bottom-right-radius: 0.8rem;
    svg {
        margin-right: 0.8rem;
    }
`;

export const ZoneDesc = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: auto;
    width: 100%;
    flex-grow: 1;
    max-height: 22rem;
    padding: 1.6rem;
    box-sizing: border-box;
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.darkBlue};
`;

export const ZoneImage = styled.img`
    max-width: 100%;
    height: 24rem;
    flex-shrink: 0;
`;

export const ZoneWrapper = styled.div`
    position: relative;
    width: 35.2rem;
    height: 44rem;
    box-shadow: 0 2px 8px 0 rgba(176, 188, 200, 0.2);
    border-radius: 0.8rem;
    line-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    cursor: pointer;

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        margin: auto;
        max-width: calc(100% - 4.8rem);
        height: 20rem;
        ${ZoneImage} {
            display: none;
        }
    }
`;
